// extracted by mini-css-extract-plugin
export default {"Header":"app_Header__ObkdY","PageHeaderStyle":"app_PageHeaderStyle__oI0j5","middle":"app_middle__S5lIr"};